import { Component } from '@angular/core';

@Component({
  selector: 'app-entity-view-and-edit',
  templateUrl: './entity-view-and-edit.component.html',
  styleUrls: ['./entity-view-and-edit.component.scss']
})
export class EntityViewAndEditComponent {

}
